// Слот экрана согласия приложения в __root (OXEM-604).
//
// Только сборка приложения: `__IS_CAPACITOR__` — константа сборки, и в вебе
// ветка с `import()` вырезается целиком (там вопрос задаёт `consent.js`).
// Монтируется после входа и шлюзов (юр-документ, онбординг) — поверх них
// второй вопрос не задаём, как и подводку пушей (`NativePushInit`).
import { lazy, type ReactElement } from "react";
import { ChunkSafe } from "@/components/shared/lazy-art";
import { useAuth } from "@/providers/auth-provider";

const NativeConsentGateLazy = __IS_CAPACITOR__ ? lazy(() => import("./native-consent-gate")) : null;

export function NativeConsentSlot(): ReactElement | null {
	const { isAuthenticated, isLoading, isOffline, pendingConsent, pendingOnboarding } = useAuth();
	if (!NativeConsentGateLazy) return null;
	if (isLoading || !isAuthenticated || isOffline || pendingConsent || pendingOnboarding)
		return null;
	return (
		<ChunkSafe fallback={null} source="native-consent">
			<NativeConsentGateLazy />
		</ChunkSafe>
	);
}
